export const JSON_URL = process.env.GATSBY_WORDPRESS_URL
export const SHOPIFY_STOREFRONT_ACCESS_TOKEN = process.env.GATSBY_SHOPIFY_STOREFRONT_ACCESS_TOKEN
export const SHOPIFY_DOMAIN = process.env.GATSBY_SHOPIFY_DOMAIN
